import { UrlQueryParamsInterface } from './query-params.interface';

/**
 * RegExp test params string
 *
 * Input: ?foo=bar&person[age]=3#dummy
 * Test group1: foo=bar&person[age]=3
 * Test group2: #dummy
 */
const URL_PARAM_TEST = /([^?#]*)(#.*)?$/;

/**
 * RegExp test pluses
 */
const PLUS = /\+/g;

/**
 * RegExp test brace
 */
const KEY_BREAKER = /([^\[\]]+)|(\[\])/g;

/**
 * RegExp test digits
 */
const DIGIT_TEST = /^\d+$/;

/**
 * Build query params object from queryString
 *
 * Input "foo=bar&person[age]=3"
 * Output:
 * {
 *  foo: "bar",
 *  person: {
 *    age: "3"
 *  }
 * }
 *
 * Function return {[key: string]: any} because then can be number, string, object or array of these elements
 *
 * @param  queryString - query string
 */
export function urlBuildQueryParams(queryString: string): UrlQueryParamsInterface {
  if (!queryString || !URL_PARAM_TEST.test(queryString)) {
    return {};
  }

  // Get query string from path or queryString
  queryString = queryString.match(URL_PARAM_TEST)[1];

  const queryParams = {};
  let pairs = queryString.split('&');
  let current: { [key: string]: any };

  // Make sure that you don't have empty param
  pairs = pairs.filter((param) => {
    return !!param;
  });

  pairs.forEach((pairElement) => {
    current = queryParams;
    let pair = pairElement.split('=');

    // if we find foo=1+1=2
    if (pair.length !== 2) {
      pair = [pair[0], pair.slice(1).join('=')];
    }

    const key = decodeURIComponent(pair[0].replace(PLUS, ' '));
    const value = decodeURIComponent(pair[1].replace(PLUS, ' '));
    const parts = key.match(KEY_BREAKER);

    // Omit last element like from key breaker "[]" - it's only use to check if param is array or object
    for (let j = 0; j < parts.length - 1; j++) {
      const part = parts[j];

      if (!current[part]) {
        // if what we are pointing to looks like an array
        current[part] = DIGIT_TEST.test(parts[j + 1]) || parts[j + 1] === '[]' ? [] : {};
      }

      current = current[part];
    }

    const labelIndex = parts.length - 1;
    const lastPart = parts[labelIndex];

    if (lastPart === '[]') {
      current.push(value);
    } else {
      current[lastPart] = value;
    }
  });

  return queryParams;
}
